import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Router } from '@angular/router';

@Component({
  selector: 'app-order-manager-select',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LoaderComponent,
    ModalHeaderComponent
  ],
  templateUrl: './order-manager-select.component.html',
  styleUrl: './order-manager-select.component.scss'
})
export class OrderManagerSelectComponent implements OnInit {
  @Input() reload: boolean = false;

  modalTitle: string = 'Manager koppelen';
  modalStyle: boolean = false;

  loading: boolean = false;

  @Input() item: any = {  };
  managerList: any[] = [];

  constructor(
    private apiService: ApiService, 
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.getManagers();
  }

  setItem (item: any) {
    this.item = item;
    this.getManagers();
  }

  getManagers() {
    if (!this.item.organisation_id) {
      return;
    }
    this.loading = true;
    this.apiService.get('/office/organisations/'+this.item.organisation_id+'/users?role=teacher,school_manager,editor&limit=50000&sort=name&direction=asc')
      .then((response: any) => {
        this.managerList = response.data.map((manager: any) => ({
          ...manager,
        }));
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
      });
  }

  select(id:string) {
    let self = this;
    this.loading = true;
    this.apiService.patch("/office/orders/" + this.item['id'], {
      manager_user_id: id
    }).then(function (response: any) {
      self.activeModal.close(true);
      self.loading = false;
    }).catch(function (e) {
      self.loading = false;
    });
  }
}
